import { Modal } from "antd";
import { Icon } from "Components";

type ThirdWhitelistingModalProps = {
  open: boolean;
  onClose: () => void;
};

const ThreeMonthWhitelistingModal = ({ open, onClose }: ThirdWhitelistingModalProps) => (< Modal
    visible={open}
    onCancel={onClose}
    footer={null}
    closable={false}
    centered
    width={552}
    bodyStyle={{ padding: 0 }}
>
    <div className="pm-modal-container">
        <div className="pm-modal-header">
            <div className="pm-modal-header-left">
                <span className="pm-modal-title">Reminder: Review Email Whitelisting</span>
            </div>
            <button className="pm-modal-close-icon"
                onClick={onClose}
                aria-label="Close">
                <Icon type="campaignModalClose" />
            </button>
        </div>

        <div className="pm-modal-body">
            <p>Email and security settings may affect delivery. </p>
            <br />
            <p>To ensure phishing campaigns are delivered successfully, please review your email whitelist configuration.</p>
        </div>

        <div className="pm-modal-footer">
            <div className="pm-modal-footer-actions">
                <button className="pm-btn-plain"
                    onClick={onClose}
                >
                    Close
                </button>
                <button className="pm-btn-primary"
                >
                    <a
                        href="https://www.venzapeak.com/support/public_resources/phishing/whitelist/#/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pm-info-action-text"
                    >
                        View Whitelisting Guide
                    </a>
                </button>
            </div>
        </div>
    </div>
</Modal >);

export default ThreeMonthWhitelistingModal;